module.exports = __webpack_public_path__ + "static/media/jaune.6c1cebce.png";